import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TF_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#TF_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TF_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#TF_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.789 6.2h8.05l-.785 1.504h-2.441v.808h1.872l-.763 1.4h-1.11v2.798l1.828-2.88 2.365 4.095h-.966l-.338-.448h-2.14l-1.507 2.783v.151l-.04-.076-.041.076v-.15l-1.506-2.784h-2.14l-.338.448h-.966l2.364-4.095 1.828 2.88V7.704h-2.442L18.789 6.2zm6.698 5.31l-.525.808h.994l-.469-.808zm-5.345 0l.525.808h-.994l.469-.808zm-3.828-.897l.831-.613.832.613-.294-1.027.807-.648-1.012-.021-.333-1.014-.332 1.014-1.012.021.807.648-.294 1.027zM28.456 10l-.831.613.293-1.027-.807-.648 1.013-.021.332-1.014.332 1.014 1.013.021-.807.648.293 1.027-.831-.613zm-3.376 7.803l.831-.612.831.613-.293-1.027.807-.648-1.012-.022-.333-1.013-.332 1.013-1.013.022.807.648-.293 1.026zm-5.39-.612l-.83.613.293-1.027-.807-.648 1.012-.022.332-1.013.333 1.013 1.012.022-.807.648.293 1.026-.83-.612zM21.97 20.2l.83-.613.832.613-.293-1.027.806-.648-1.012-.022-.332-1.013-.333 1.013-1.012.022.807.648-.293 1.027z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#2E42A5", stroke: "#fff", d: "M-.5-.5h13v11h-13z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TF_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: -1,
      y: -1,
      width: 14,
      height: 12
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", stroke: "#fff", d: "M-.5-.5h13v11h-13z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#TF_svg__c)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M8 0h4v10H8V0z", fill: "#F50100" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0h4v10H0V0z", fill: "#2E42A5" }), /* @__PURE__ */ e.createElement("path", { d: "M4 0h4v10H4V0z", fill: "#F7FCFF" }))))
), a = t;
export {
  a as default
};
